//useRole

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getRoles,
  RoleResponse,
  Permission,
  updateRole,
  RoleFormData,
} from '../api/role';
import { toast } from 'react-toastify';

export interface RoleDto {
  id: string;
  name: string;
  key: string;
  permissions: Permission[];
}

export const parseRoleDto = (role: RoleResponse): RoleDto => {
  return {
    id: role.id,
    name: role.name,
    key: role.key,
    permissions: role.permissions,
  };
};

export const useRoles = () => {
  return useQuery({
    queryKey: ['roles'],
    queryFn: getRoles,
    select: (data) => data.map(parseRoleDto),
  });
};

export const useUpdateRole = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, role }: { id: string; role: RoleFormData }) =>
      updateRole(id, role),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] });
      toast.success('Cập nhật phân quyền thành công');
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
};
